import {Box, Center, Image, Flex, Text} from '@chakra-ui/react'
import PauseVideoIcon from '@assets/svgs/exam/pause-video.svg'
import PlayVideoIcon from '@assets/svgs/exam/play-video.svg'
import PreviousVideoIcon from '@assets/svgs/exam/previous-video.svg'
import NextVideoIcon from '@assets/svgs/exam/next-video.svg'
import {useEffect, useRef, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {
  updateIsPauseAudio,
  updateAudioTime,
  updateIsOpenBadPause,
} from '@redux/exam-result/examResult'

const ControlAudio = ({audioRef}: any) => {
  const {dataExamResult, isPauseAudio, audioTime, audioClips} = useSelector(
    (state: any) => state.examResult,
  )
  const [isMouseDown, setIsMouseDown] = useState(false)
  const [percentMouseMove, setPercentMouseMove] = useState(0)
  const wrapAudioRef = useRef<any>(null)
  const dispatch = useDispatch()
  const updateFrequency = 100 // Tần suất cập nhật thời gian tính bằng mili giây

  useEffect(() => {
    audioRef.current = new Audio(dataExamResult?.transcript_review?.audio)
    audioRef.current.addEventListener('loadedmetadata', function () {
      const duration = Number(audioRef.current.duration.toFixed(0))
      dispatch(updateAudioTime({...audioTime, duration}))
    })
    audioRef.current.addEventListener('timeupdate', function () {
      const duration = Number(audioRef.current.duration.toFixed(0))
      const currentTime = Number(audioRef.current.currentTime.toFixed(0))
      const currentWordTime = audioRef.current.currentTime
      if (audioRef.current.currentTime >= audioRef.current.duration) {
        dispatch(updateIsPauseAudio(true))
      }
      dispatch(updateAudioTime({duration, currentTime, currentWordTime}))
    })
  }, [])

  useEffect(() => {
    if (!audioRef.current) return
    audioRef.current.addEventListener('customTimeUpdate', () => {
      const duration = Number(audioRef.current.duration.toFixed(0))
      const currentTime = Number(audioRef.current.currentTime.toFixed(0))
      const currentWordTime = audioRef.current.currentTime
      if (audioRef.current.currentTime >= audioRef.current.duration) {
        dispatch(updateIsPauseAudio(true))
      }
      dispatch(updateAudioTime({duration, currentTime, currentWordTime}))
    })

    audioRef.current.addEventListener('play', () => {
      const interval = setInterval(() => {
        if (audioRef.current.paused || audioRef.current.ended) {
          clearInterval(interval)
        } else {
          triggerCustomTimeUpdate()
        }
      }, updateFrequency)
    })
  }, [])

  function triggerCustomTimeUpdate() {
    const event = new Event('customTimeUpdate')
    audioRef.current.dispatchEvent(event)
  }

  // Bật tắt audio
  useEffect(() => {
    if (isPauseAudio) {
      audioRef.current.pause()
    } else {
      audioRef.current.play()
      dispatch(updateIsOpenBadPause(false))
    }
  }, [isPauseAudio])

  useEffect(() => {
    if (isMouseDown) {
      document.addEventListener('mousemove', handleMouseMove)
    }
    return () => {
      document.removeEventListener('mousemove', handleMouseMove)
    }
  }, [isMouseDown])

  useEffect(() => {
    if (isMouseDown) {
      document.addEventListener('mouseup', handleMouseUp)
    }
    return () => {
      document.removeEventListener('mouseup', handleMouseUp)
    }
  }, [isMouseDown, audioRef.current])

  const handleToggleAudio = () => {
    dispatch(updateIsPauseAudio(!isPauseAudio))
  }

  const handlePreviousAudio = () => {
    const index = audioClips.findIndex(
      (item: any) =>
        (audioTime.currentTime || 0) >= item.start_time &&
        (audioTime.currentTime || 0) < item.start_time + item.duration + 0.5,
    )
    if (index === 0) {
      audioRef.current.currentTime = audioClips[index].start_time
    } else {
      audioRef.current.currentTime = audioClips[index - 1].start_time
    }
  }

  const handleNextAudio = () => {
    const index = audioClips.findIndex(
      (item: any) =>
        (audioTime.currentTime + 0.5 || 0) >= item.start_time &&
        (audioTime.currentTime || 0) <
          (item.start_time + item.duration).toFixed(0),
    )

    if (index === audioClips.length - 1) {
      audioRef.current.currentTime =
        audioClips[index].start_time + audioClips[index].duration
    } else {
      audioRef.current.currentTime = audioClips[index + 1].start_time
    }
  }

  const handleClickProgress = (e: any) => {
    const {layerX} = e.nativeEvent
    const width = wrapAudioRef.current.offsetWidth
    const percent = layerX / width
    const currentTime = audioTime.duration * percent
    audioRef.current.currentTime = currentTime
  }

  const handleMousedown = (event: any) => {
    document.body.style.cursor = 'pointer'
    setIsMouseDown(true)
    const percent = getPercentAudio(event) * 100
    setPercentMouseMove(percent)
  }

  const handleMouseUp = (event: any) => {
    document.body.style.cursor = 'unset'
    setIsMouseDown(false)
    const percent = getPercentAudio(event)
    const currentTime = audioTime.duration * percent
    if (!audioRef.current) {
      return
    }
    audioRef.current.currentTime = currentTime
  }

  const handleMouseMove = (event: any) => {
    let percent = getPercentAudio(event) * 100
    if (percent <= 0) percent = 0
    if (percent >= 100) percent = 100
    setPercentMouseMove(percent)
  }

  const getPercentAudio = (event: any) => {
    const clientX = event.clientX
    const clientWidth = wrapAudioRef.current.clientWidth
    const offsetLeft = wrapAudioRef.current.getBoundingClientRect().left
    const currentMouse = clientX - offsetLeft
    const percent = currentMouse / clientWidth
    return percent
  }

  return (
    <Box maxW={'860px'} mx={'auto'} px={'4px'} py={'16px'}>
      <Flex gap={'16px'} alignItems={'center'}>
        <Flex gap={'16px'} alignItems={'center'}>
          <Center
            cursor={'pointer'}
            h={'40px'}
            w={'40px'}
            borderRadius={'50%'}
            bg={'linear-gradient(180deg, #B2B2B2 0%, #4D4D4D 100%)'}
            onClick={handleToggleAudio}>
            <Image src={isPauseAudio ? PlayVideoIcon : PauseVideoIcon} />
          </Center>
          <Flex gap={'16px'}>
            <Image
              src={PreviousVideoIcon}
              cursor={'pointer'}
              w={'24px'}
              h={'24px'}
              onClick={handlePreviousAudio}
            />
            <Image
              src={NextVideoIcon}
              cursor={'pointer'}
              w={'24px'}
              h={'24px'}
              onClick={handleNextAudio}
            />
          </Flex>
        </Flex>
        <Flex
          className="wrap-audio"
          ref={wrapAudioRef}
          userSelect={'none'}
          flex={1}
          gap={{base: '2px', md: '4px'}}
          position={'relative'}
          cursor={'pointer'}
          h={'4px'}
          transition={'0.3s'}
          _hover={{
            h: '6px',
            '.progress-audio': {
              h: '12px',
              w: '12px',
            },
          }}
          onMouseDown={handleMousedown}
          onClick={handleClickProgress}>
          <Box
            className="progress-audio"
            pointerEvents={'none'}
            transition={isMouseDown ? '0s' : '0.3s'}
            left={
              isMouseDown
                ? `${percentMouseMove}%`
                : `${(audioTime.currentTime / audioTime.duration) * 100 || 0}%`
            }
            w={'8px'}
            h={'8px'}
            borderRadius={'50%'}
            bg={'#262626'}
            position={'absolute'}
            top={'50%'}
            zIndex={2}
            cursor={'pointer'}
            transform={'translate(-50%, -50%)'}></Box>
          <Box
            h={'100%'}
            bg={'#262626'}
            position={'absolute'}
            top={'50%'}
            transform={'translateY(-50%)'}
            zIndex={1}
            pointerEvents={'none'}
            transition={isMouseDown ? '0s' : '0.3s'}
            w={
              isMouseDown
                ? `${percentMouseMove}%`
                : `${(audioTime.currentTime / audioTime.duration) * 100 || 0}%`
            }
            borderRadius={'2px'}></Box>
          {audioClips?.map((item: any, index: any) => {
            return (
              <Box
                key={index}
                w={`${(item.duration / audioTime.duration) * 100}%`}
                borderRadius={'2px'}
                bg={'#D9D9D9'}></Box>
            )
          })}
        </Flex>
        <Flex alignItems={'center'} w={'110px'} gap={'4px'}>
          <TimeDisplay totalSeconds={audioTime.currentTime || 0} />
          <Text fontSize={'16px'} fontWeight={500}>
            /
          </Text>
          <TimeDisplay totalSeconds={audioTime.duration} />
        </Flex>
      </Flex>
    </Box>
  )
}

const TimeDisplay = ({totalSeconds}: any) => {
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60

  return (
    <Text
      fontSize={'16px'}
      fontWeight={500}
      w={'48px'}
      color={'#434343'}
      style={{
        textWrap: 'nowrap',
      }}>
      {minutes < 10 ? `0${minutes}` : minutes}:
      {seconds < 10 ? `0${seconds}` : seconds}
    </Text>
  )
}

export default ControlAudio
